import { Button } from '@/components/UI/Button'
import { Dialog } from '@/components/UI/Dialog'
import { IconExternalLink } from '@tabler/icons-react'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  onClose: () => void
  /** storybookで確認する際に、スクロール可にするためのフラグ。raundで利用する場合にはtrue */
  scrollLock?: boolean
  ilustMaps?: { caption: string; url: string | null }[] | null
  /** ダイアログのタイトル（管理画面の mapCaption を渡す。未指定時は翻訳キーのデフォルト値を使用） */
  title?: string | null
}

/**
 * `Raund-Replace / Screen UI / SPOT-PDF-MAP`のダイアログコンポーネント
 *
 * /spots のPDFマップ・イラストマップ・ルートマップを選択したときに表示される
 */
export const DialogIlustmap = memo(({ onClose, scrollLock = false, ilustMaps, title }: Props) => {
  const { t } = useTranslation()

  return (
    <Dialog selectorState={true} showCloseButton={false} lockScroll={scrollLock} closeAction={onClose}>
      <h1 className="text-black text-center text-[16px] font-bold leading-[24px]">
        {title || t('spot_detail.ilustmap.title', 'イラストマップ')}
      </h1>

      {ilustMaps && ilustMaps.length > 0 && (
        <ul className="mt-6 flex flex-col items-center">
          {ilustMaps.map((map, i) => (
            <li key={`${map.caption}-${i}`} className="mb-[16px] last:mb-0 w-full">
              {map.url ? (
                <a
                  href={map.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full text-[14px] leading-[1.4] text-black underline"
                >
                  {map.caption}
                  <IconExternalLink
                    size={14}
                    stroke={2}
                    aria-hidden="true"
                    className="ml-[8px] inline-block align-middle"
                  />
                </a>
              ) : (
                <p className="text-center text-[14px] leading-[1.4] text-black">{map.caption}</p>
              )}
            </li>
          ))}
        </ul>
      )}

      <div className="mt-6 flex justify-center">
        <Button label={t('common.close', '閉じる')} variant="primary" size="md" onClick={onClose} fullWidth />
      </div>
    </Dialog>
  )
})
